<template>
 <Head>
    <title> View Announcement | {{announcement.announcement_title}} | {{$page.props.appName}}</title>
    <meta name="description" :content="'View Announcement' + $page.props.appName">
  </Head>
    <div class="p-3">
    
        <div class="mt-2 bg-gray-100 p-3 xl:w-1/2 lg:w-1/2 md:w-full sm:w-full w-full">
    
            <h1 class="text-3xl font-bold">{{announcement.announcement_title}}</h1>
    
            <p class="text-sm">Posted by {{posted_by}} on {{created_at}} </p>
    
            <p class="font-semibold p-2">{{announcement.announcement_message}}</p>
    
            <a :href="'/file/' + announcementfile?.filename"><button class="bg-black text-white font-bold p-2 my-1" v-if="announcementfile?.filename">DOWNLOAD FILE</button></a>
    
            <div class="p-3 bg-white">
    
                <input class="inline mr-1" type="checkbox" :checked="staffannouncement.seen == 1" :disabled="staffannouncement.seen == 1" @change="updateSeen">
    
                <p class="inline">Please agree that you have read and understood this announcement</p>
    
                <p class="text-xs">If you do not click the box above, then this announcement will not be flagged as seen to management.</p>
    
            </div>
    
        </div>
    
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import { Link } from "@inertiajs/inertia-vue3";
import { Head } from '@inertiajs/inertia-vue3'

export default {
    components: { Link,Head },
    props: {
        staffannouncement: Object,
        announcement: Object,
        posted_by: String,
        created_at: String,
        announcementfile: Object,
    },
    layout: Layout,
    methods: {
        updateSeen: function() {
            this.$inertia.post('/announcements/seen/' + this.staffannouncement.id, { preserveState: true })

        }
    }
}
</script>